{
  "version": 1,
  "asset_id": "d51b291f-7fa8-4b45-adc5-083b2be88625",
  "project_id": "5ebebed5-d757-4c4f-9e26-a06d6761c2a0",
  "url": "/__l5e/assets-v1/d51b291f-7fa8-4b45-adc5-083b2be88625/heinz-huber.png",
  "r2_key": "a/v1/5ebebed5-d757-4c4f-9e26-a06d6761c2a0/d51b291f-7fa8-4b45-adc5-083b2be88625/heinz-huber.png",
  "original_filename": "heinz-huber.png",
  "size": 35638,
  "content_type": "image/png",
  "created_at": "2026-06-25T00:53:41Z"
}
